module.exports = __webpack_public_path__ + "img/Class-B-Desktop.ea4c4f9c.jpg";